
import "../styles/main.scss";

import LazyLoad from "vanilla-lazyload"
import fslighbox from 'fslightbox';
import MobileNavigation from "./modules/mobile-navigation.js";
import ScrollAction from "./modules/scroll-action";
import Tabs from "./modules/tabs";
import Accordion from "./modules/accordion";
import SubMenuToggle from "./modules/sub-menu-toggle";
import './use-cases/slider'
import './use-cases/interacts'
import "./use-cases/reveal"
import "./use-cases/forms"
import "./use-cases/modal"
import "./use-cases/woocommerce";
import "./vue/index"

new LazyLoad({elements_selector: ".lazy", load_delay: 300, callback_loaded: el => el.parentNode.classList.remove('is-loading')})
new MobileNavigation({
  burger: ".js-burger-menu",
  overlay: ".js-menu-overlay",
  menu: ".js-mobile-menu",
  cancel: ".js-menu-cancel"
});
new ScrollAction({
  wrapper: ".js-site-header",
  offset: ".js-site-header",
  classToAdd: "is-sticky"
}).init();
let mainNavs = document.querySelectorAll('.nav-primary .nav');
if (mainNavs) {
  // console.log(mainNavs);
  mainNavs.forEach(nav => {
    new SubMenuToggle(nav);
  });
}
// new Accordion(".js-mobile-menu", {
// 	items:'.js-sub-menu-toggler',
// 	collapse: true,
// 	classToAdd: 'is-active'
// });

if (document.querySelector(".js-accordion-wrapper")) {
  new Accordion(".js-accordion-wrapper");
}

const tabs1 = new Tabs({
  nav_item: ".js-nav-tabs__item",
  tab_pane: ".js-tab__pane"
});

tabs1.init();

window.addEventListener('load', () => {
  require('./modules/swipers');
});
